import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import Countdown from "react-countdown";
import stl from "./CampaignModal.module.css";
import { useEffect, useState } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
var CampaignModal = function CampaignModal(_ref) {
  var _campaignsList$;
  var modalName = _ref.modalName,
    doClose = _ref.doClose,
    campaignData = _ref.campaignData,
    isPostModal = _ref.isPostModal,
    dataFromPost = _ref.dataFromPost;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useState = useState(0),
    tab = _useState[0],
    setTab = _useState[1];
  var campaignsList = campaignData || [];

  // Fallback for backward compatibility
  if (campaignsList.length === 0) {
    if (dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.cash) campaignsList.push(_objectSpread(_objectSpread({}, dataFromPost.cash), {}, {
      title: t("cash_offer", {
        ns: "web_common"
      }),
      type: 'cash'
    }));
    if (dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.finance) campaignsList.push(_objectSpread(_objectSpread({}, dataFromPost.finance), {}, {
      title: t("financing_offer", {
        ns: "web_common"
      }),
      type: 'finance'
    }));
  }
  useEffect(function () {
    // Reset tab if out of bounds or data changes
    setTab(0);
  }, [dataFromPost]);
  return /*#__PURE__*/React.createElement(BottomSheetPopup, {
    blueCloseIcon: true,
    show: modalName,
    onClose: function onClose() {
      return doClose();
    }
  }, isPostModal ? /*#__PURE__*/React.createElement("div", {
    className: stl.tabsContainer
  }, /*#__PURE__*/React.createElement("strong", null, campaignsList.length > 1 ? t("offer_details", {
    ns: "web_common"
  }) : (_campaignsList$ = campaignsList[0]) === null || _campaignsList$ === void 0 ? void 0 : _campaignsList$.title), campaignsList.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: stl.tabsHead
  }, campaignsList.map(function (campaign, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: tab === index ? stl.active : "",
      onClick: function onClick() {
        return setTab(index);
      }
    }, campaign.title);
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.tabsContent
  }, campaignsList.map(function (campaign, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        display: tab === index ? "block" : "none"
      }
    }, campaign.desktop_image && /*#__PURE__*/React.createElement("img", {
      src: campaign.desktop_image,
      alt: "img"
    }), campaign.counter_timestamp || dataFromPost !== null && dataFromPost !== void 0 && dataFromPost.counter_timestamp ? /*#__PURE__*/React.createElement("div", {
      className: stl.countdownWrapper
    }, /*#__PURE__*/React.createElement("strong", null, t("remaining_offer", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement(Countdown, {
      date: (campaign.counter_timestamp || (dataFromPost === null || dataFromPost === void 0 ? void 0 : dataFromPost.counter_timestamp)) * 1000,
      daysInHours: true,
      onComplete: function onComplete() {},
      renderer: function renderer(_ref2) {
        var hours = _ref2.hours,
          minutes = _ref2.minutes,
          seconds = _ref2.seconds,
          days = _ref2.days;
        return /*#__PURE__*/React.createElement("div", {
          className: stl.countdown
        }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " ", ":", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
      }
    })) : null, /*#__PURE__*/React.createElement("h2", null, campaign.text, " "), campaign.description && /*#__PURE__*/React.createElement("div", {
      className: stl.description,
      dangerouslySetInnerHTML: {
        __html: campaign.description
      }
    }));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("strong", null, (campaignData === null || campaignData === void 0 ? void 0 : campaignData.title) || (modalName === "finance" ? t("financing_offer", {
    ns: "web_common"
  }) : t("cash_offer", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("img", {
    src: campaignData === null || campaignData === void 0 ? void 0 : campaignData.desktop_image,
    alt: (campaignData === null || campaignData === void 0 ? void 0 : campaignData.title) || "Campaign offer"
  }), campaignData !== null && campaignData !== void 0 && campaignData.counter_timestamp ? /*#__PURE__*/React.createElement("div", {
    className: stl.countdownWrapper
  }, /*#__PURE__*/React.createElement("strong", null, t("remaining_offer", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(Countdown, {
    date: (campaignData === null || campaignData === void 0 ? void 0 : campaignData.counter_timestamp) * 1000,
    daysInHours: true,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref3) {
      var hours = _ref3.hours,
        minutes = _ref3.minutes,
        seconds = _ref3.seconds,
        days = _ref3.days;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.countdown
      }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " :", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
    }
  })) : null, /*#__PURE__*/React.createElement("h2", null, campaignData === null || campaignData === void 0 ? void 0 : campaignData.text, " "), (campaignData === null || campaignData === void 0 ? void 0 : campaignData.description) && /*#__PURE__*/React.createElement("div", {
    className: stl.description,
    dangerouslySetInnerHTML: {
      __html: campaignData.description
    }
  })));
};
export default CampaignModal;